import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { bank_account_update_form_keys } from './bank-account-update.constants';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { IIbanObject } from '../../athora.constants';

@Component({
  selector: 'app-bank-account-update',
  standalone: false,
  templateUrl: './bank-account-update.component.html',
  styleUrl: './bank-account-update.component.scss'
})
export class BankAccountUpdateComponent implements OnChanges, OnDestroy {

  @Input() form: FormGroup;
  @Input() ibanList: IIbanObject[];
  @Input() currentBankAccount: string;

  keys: IFormKey[] = CommonUtils.assign(bank_account_update_form_keys);

  destroy$ = new Subject();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ibanList'] && changes['ibanList'].currentValue) {
      this.populateIbanOptions();
    }
  }

  populateIbanOptions(): void {
    this.keys = CommonUtils.populateIbanOptions(this.keys, this.filteredIbanList);
  }

  get showNoCCAvailableErrorMessage(): boolean {
    return (this.ibanList && this.ibanList.length === 1 && this.ibanList.some(obj => obj?.abiRapporto + obj?.cabRapporto + obj?.numeroRapporto === this.currentBankAccount));
  }

  get filteredIbanList(): IIbanObject[] {
    return this.ibanList?.filter(obj => obj?.abiRapporto + obj?.cabRapporto + obj?.numeroRapporto !== this.currentBankAccount);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
